module.exports = __webpack_public_path__ + "static/media/eldorado.6e58f361.svg";